import { IModel } from '../base/annotation';
import { Named } from '../base/named';
import { Metamodel } from '../base/model';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { IRadioOption } from '../../interfaces/IRadioOption';

let columnIdIndex = 0;

export interface IParquetPorperties {
    logicalType: string;
    physicalType: string;
    unit: 'MILLIS' | 'MICROS' | 'NANOS';              
}

@Metamodel.model({
    name: 'column',
    display: [shellStringResources.Column, shellStringResources.Columns],
    referable: true,
    globalScope: true
})
export class Column extends Named {
    public static readonly MODEL: IModel;

    // global unique id, used for ngFor trackby perf.
    // eslint-disable-next-line @typescript-eslint/naming-convention
    public __id: number;

    /*
        Physical type. Ideally a enumeration for the type of dataset
    */
    public columnType?: string;
    public columnTypeIcon?: string;

    // Json path as a column
    public path?: string;

    public precision?: number;

    public scale?: number;

    public format?: string;

    public culture?: string;

    public size?: string;

    public unitOptions?: Array<IRadioOption<string>>;

    public unit?: string;

    public required?: boolean;

    public isNullable?: boolean;

    public datetimeKind?: string;

    // 1-based index
    public index?: number;

    // only for display usage
    public logicalType?: string;
    public physicalType?: string;

    public parquetPorperties?: IParquetPorperties;

    // only for additional columns
    public isAdditionalColumn?: boolean;

    public isBigDecimal?: boolean;

    /*
        Represents the physical name and its description
    */
    constructor(name?: string, description?: string) {
        super(name, description);
        this.__id = ++columnIdIndex;
    }

    public toString(): string {
        return JSON.stringify({
            type: this.columnType,
            precision: this.precision,
            scale: this.scale
        });
    }

    public toIdentifier(): string {
        return (this.name || this.index || this.path || '') + '';
    }
}
